module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina', [_c('breadcrumb', {
    attrs: {
      "slot": "breadcrumb",
      "itens": this.breadcrumb
    },
    slot: "breadcrumb"
  }), _c('noticias', {
    attrs: {
      "slot": "principal",
      "pagination": true,
      "perPage": 10
    },
    slot: "principal"
  }), _c('sidebar', {
    attrs: {
      "slot": "lateral"
    },
    slot: "lateral"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b8e948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/Noticias.vue
// module id = 500
// module chunks = 0